import React from "react";

function AppDialogFooter({ className = "", startContent = null, children, ...rest }) {
  if (!startContent && !children) {
    return null;
  }

  const classes = ["ds-dialog__footer", className].filter(Boolean).join(" ");

  return (
    <footer className={classes} {...rest}>
      {startContent ? (
        <div className="ds-dialog__footer-start">{startContent}</div>
      ) : null}
      {children ? (
        <div className="ds-dialog__footer-actions">{children}</div>
      ) : null}
    </footer>
  );
}

AppDialogFooter.appDialogZone = "footer";

export default AppDialogFooter;
